<script lang="ts">
  import { browser } from '$app/environment';
  import { onNavigate } from '$app/navigation';
  import { NewsArticleAdUnits } from '$lib/services/ads/enums';
  import { isInterscrollerAdFilled, scrollPositionsStore } from '$lib/store';
  import Logger from '$lib/utils/logger';
  import { onMount } from 'svelte';
  import {
    defineAndConfigureSlot,
    formatAdUnit,
    initializeAdServices,
    onImpressionViewable,
    setupAdIntersectionObserver
  } from './GoogleAdComponent';
  import { AdConfig } from './config';
  import { PersistentStore } from '$lib/utils/persistent-store';
  import { CHILD_DIRECTED_TREATMENT } from '$lib/constants/persistent-store';

  export let adType: keyof typeof AdConfig;
  // export let categoryName = '';
  export let adUnitName: string;
  export let placementName: string = '';
  export let utm_medium: string = '';
  let adUnitFullName: string;
  let showAdSlots: boolean;

  Logger.log('placementName', placementName);
  adUnitFullName = utm_medium
    ? adUnitName
    : adUnitName === NewsArticleAdUnits.L2_INTERSCROLLER
      ? '/23059745623/tracfoneportal_interscroller/NewsL2_interscroller_btf1'
      : formatAdUnit(adUnitName);
  Logger.log('adUnitFullName', adUnitFullName);

  let adContainer: HTMLDivElement;
  // const adUnitFullName = '/6355419/Travel/Europe/France/Paris';

  const adUnitDimension = AdConfig[adType].googleAdDimension;

  const createContainerId = () => {
    return `${adUnitName}-${Math.floor(Math.random() * 10000)}`;
  };
  const adUnitId = createContainerId();

  onMount(() => {
    if (!browser) return;

    showAdSlots = PersistentStore.get(CHILD_DIRECTED_TREATMENT) === true;
    if (!showAdSlots) {
      setupGoogleTag();
    }
  });

  function collapseAdWrapper() {
    if (adContainer) {
      adContainer.style.height = '0';
    }
    if (adUnitFullName.includes('interscroller')) {
      Logger.log('interscroller ad not filled');
      isInterscrollerAdFilled.set(false);
    }
  }

  function expandAdWrapper() {
    if (adContainer) {
      adContainer.style.height = `${AdConfig[adType].containerDimension.height}px`;
    }
    if (adUnitFullName.includes('interscroller')) {
      Logger.log('interscroller ad filled');
      isInterscrollerAdFilled.set(true);
    }
  }

  export function setupGoogleTag() {
    const googletag = (window as Window).googletag || { cmd: [] };

    googletag.cmd.push(() => {
      const targetSlot = defineAndConfigureSlot(adUnitFullName, adUnitDimension, adUnitId);
      targetSlot.setTargeting('oem', utm_medium);
      initializeAdServices();
      googletag
        .pubads()
        .addEventListener('impressionViewable', (event) => onImpressionViewable(event, targetSlot));
      // window.impressionViewableAdded = true;
      // }

      googletag.pubads().addEventListener('slotRenderEnded', function (event) {
        if (event.slot === targetSlot) {
          if (!event.isEmpty) {
            Logger.log('slot fills', event.slot.getAdUnitPath());
            expandAdWrapper();
          } else {
            collapseAdWrapper();
          }
        }
      });

      googletag.pubads().addEventListener('slotOnload', function (event) {
        if (event.slot === targetSlot) {
          Logger.log('slot loaded');
          // Ad has loaded successfully
        }
      });
    });

    setupAdIntersectionObserver(adUnitId);

    return {
      destroy: () => {
        !showAdSlots &&
          googletag.cmd.push(() => {
            googletag.destroySlots();
          });
      }
    };
  }

  // onNavigate(() => {
  //   const googletag = (window as Window).googletag || { cmd: [] };
  //   const slot = googletag
  //         .pubads()
  //         .getSlots().find((s: any) => s.getSlotElementId() === adUnitId);
  //         console.log('slot', slot);
  //         if (slot) {
  //         const adUnitPath = slot?.getAdUnitPath();
  //         // Assuming the sizes targeting is a JSON string of number pairs
  //         const sizesStr = slot?.getTargeting('sizes')[0];
  //         const sizes: number[][] = JSON.parse(sizesStr);
  //         setupTamBids(adUnitId, adUnitPath, sizes, slot);
  //       }
  //   setupAdIntersectionObserver(adUnitId);
  // });

  onNavigate(async () => {
    if (!browser) return;
    collapseAdWrapper();
    scrollPositionsStore.set({
      sectionName: '',
      position: 0
    });
    showAdSlots = PersistentStore.get(CHILD_DIRECTED_TREATMENT) === true;
    if (browser && window.googletag && !showAdSlots) {
      window.googletag.cmd.push(() => {
        window.googletag.destroySlots();
        requestAnimationFrame(async () => {
          if (typeof window !== 'undefined' && browser && document.getElementById(adUnitId)) {
            await setupGoogleTag();
          }
        });
      });
    }
  });

  // onDestroy(() => {
  //   if (browser) {
  //     window?.googletag?.destroySlots();
  //   }
  // });
</script>

{#if !showAdSlots}
  <div
    bind:this={adContainer}
    class="ad-class ad-container"
    style="--width:{AdConfig[adType].containerDimension.width}px; --height:0"
  >
    <div id={adUnitId} />
  </div>
{/if}

<style>
  .ad-class {
    --fallback-margin: 12px auto;
    margin: var(--margin, var(--fallback-margin));
    aspect-ratio: var(--aspect-ratio, 300 / 250);
    height: var(--height);
    width: var(--width);
  }

  .ad-container {
    display: table-cell;
    width: 100vw;
    text-align: center;
    vertical-align: middle;
  }
</style>
